import MetricDetailPin from './MetricDetailPin';

export default MetricDetailPin;
